import { render, staticRenderFns } from "./inputBox.vue?vue&type=template&id=0221fb96&scoped=true"
import script from "./inputBox.vue?vue&type=script&lang=js"
export * from "./inputBox.vue?vue&type=script&lang=js"
import style0 from "./inputBox.vue?vue&type=style&index=0&id=0221fb96&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221fb96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0221fb96')) {
      api.createRecord('0221fb96', component.options)
    } else {
      api.reload('0221fb96', component.options)
    }
    module.hot.accept("./inputBox.vue?vue&type=template&id=0221fb96&scoped=true", function () {
      api.rerender('0221fb96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audioPackage/inputBox.vue"
export default component.exports